import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Container, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { connect } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Switch from "react-switch";
import { setAppCustomTitle } from "../../reducers/ThemeOptions";
import Common from "../Common";
import "./index.css";
import requestApiService from "../../services/requestApi.service";
import CratioFileUploader from "../Common/CratioFileUploader";
import { checkIsAdmin, getServerDomainURL, getServerURL, loadWebWidgetData, parseJSON, uploadFileIntoS3,getBackButton, confirmBoxWithImage, getWarningIcon, isMobile } from "../../Common/Appcommon";
import WebsiteWidget from "./WebsiteWidget";
import { useAppContext } from "../../Context/AppContext";
import CopyToClipboard from "react-copy-to-clipboard";
import { WebCallContextProvider } from "../Agents/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import NoWidgetIcon from '../../assets/utils/images/Widget.png';
import NoRecordFound from "../Common/NoRecordFound";
const Widgets = () => {
    const isAdmin = checkIsAdmin();
    const savebtn = useRef();
    const { theme } = useAppContext();
    const { handleSubmit: handleActionFormSubmit, control, formState: { errors }, reset } = useForm();
    const [formData, setFormData] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [showLoader, setShowLoader] = useState(true);
    const [agentsList, setAgentsList] = useState([]);
    const [isConfigView, setIsConfigView] = useState(false);
    const [showModal, setShowModal] = useState(false);
    //const [isGenerateCode, setIsGenerateCode] = useState(false);
    let isGenerateCode = false;
    const [isCopied, setTextCopied] = useState(false);
    const [scriptTagContent, setScriptTagContent] = useState("HELLO");

    useEffect(() => {
        const fetchData = async () => {
            let formdata = await loadWebWidgetData();
            setFormData(formdata);
            loadDefaultData();
            await getAgentsList();
            setShowLoader(false);
        }
        fetchData();
    },[]);

    useEffect(() =>{
        if(isCopied){
            setTimeout(() => {
                setTextCopied(false);
              }, 2000);
        }
    },[isCopied])

    const loadDefaultData = () => {
        setRowData(prev => ({
            subtitle: "Talk to customer support",
            button_color: "#16BDCA",
            text_color: "dark",
            position: "right",
            call_btn_text: "Call us",
            welcome_text: "An agent is ready solve your questions."
        }))
    }

    const getAgentsList = async () => {
        let reqobj = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "GET_AGENT_DETAILS",
        };
        let response = await requestApiService.processServerRequest(reqobj);
        if(response.issuccess){
            let data = [];
            for (const row of response.data) {
                data.push({
                    label: row["Agent_Name"],
                    value: row["table_250_id"],
                    voiceid:row['voice_id'],
                });
            }
            setAgentsList(data);
        }
    }

    const getScriptTagContent = async (currentRow) => {
        let referenceHash = currentRow['token'];
        let position = currentRow['position'].toUpperCase();
        let widgetUrl = getServerDomainURL();
        let serverUrl = getServerURL(true);
        serverUrl = serverUrl + "/widget.min.js?_="+ Math.random();
        let appUrl = window.location.protocol+"//"+window.location.hostname;
        let scriptTag = "<script>\n" +
            "(function (w, d, s, u) {\n" +
            "w.crwawc = {\n" +
            "url: \""+appUrl+"\",\n" +
            "options: {\n" +
            "        waId: \""+referenceHash+"\",\n" +
            "        widgetPosition: \""+position+"\",\n" +
            "        widgetUrl: \"call-widget\",\n" +
            "    },\n" +
            "};\n" +
            "var h = d.getElementsByTagName(s)[0],\n" +
            "j = d.createElement(s);\n" +
            "j.async = true;\n" +
            "j.src = \""+serverUrl+"\",\n" +
            "h.parentNode.insertBefore(j, h);\n" +
            "})(window, document, \"script\");\n" +
            "</script>";
            //, \""+widgetUrl+"\"
        setScriptTagContent(scriptTag)

    }

    const handleInputChange = (e, type = "") => {
        if( type === "agent" ){
            setRowData(prev => ({
                ...prev,
                [type]: e
            }));
        }else if(type === "checkbox"){
            let {name, checked} = e.target;
            setRowData(prev => ({
                ...prev,
                [name]: checked
            }));
        }else{
            let {name, value} = e.target;
            setRowData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    }

    const handleFileUpload = async (e, name) => {
        setShowLoader(true);
        let { formInputData } = await uploadFileIntoS3(e, rowData, name);
        if(Object.keys(formInputData).length > 0){
            setRowData(prev => ({
                ...prev,
                [name] : JSON.stringify(formInputData[name]),
            }));
        }
        setShowLoader(false);
    };

    const clearFile = (name) => {
        setRowData(prev => ({
            ...prev,
            [name] : ""
        }));
    }

    const onSubmitData = async () => {
        let reqobj = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "SAVE_WIDGET",
            formData: rowData
        };
        let response = await requestApiService.processServerRequest(reqobj);
        if(response.issuccess){
            let resData = response.data;
            setFormData(resData['formrows']);
            let currentRow = resData['currentRow'];
            await getScriptTagContent(currentRow);
            if(isGenerateCode){
                setShowModal(!showModal); 
                let agent_id = currentRow["agent_id"];
                const selectedOption = agentsList.find(option => option.value === agent_id);
                const updatedRow = {
                    ...currentRow,
                    agent: selectedOption,
                }
                setRowData(updatedRow);
                getConfigViewContainner();
                isGenerateCode = false;
            } else {
                // setIsConfigView(false);
                openWidgetConfig(null);
            }
        }
    }

    const updateStatus = async (data) => {
        let formid = data.id;
        let reqobj = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "UPDATE_WIDGET_STATUS",
            formid: formid,
            status: data.status === "Active" ? "Inactive" : "Active"
        };
        let response = await requestApiService.processServerRequest(reqobj);
        if(response.issuccess){
            setFormData(response.data);
        }    
    };
      

    const deleteData = async (formid, name) => {
        let title = `Are you sure you want to delete the "${name}" widget?`;
        let confirm = await confirmBoxWithImage(title, "", getWarningIcon(), "Delete");
        if(confirm){
            let reqobj = {
                ENTITY: "AIPROCESSOR",
                OPERATION: "DELETE_WIDGET",
                formid: formid
            };
            let response = await requestApiService.processServerRequest(reqobj);
            if(response.issuccess){
                setFormData(response.data);
            }
        }
    }

    const saveData = () => {
        if(savebtn.current){
            savebtn.current.click();
        }
    }

    const fieldValidate = (type,label='') => {
        const value = rowData[type];
        if(type === "agent"){
            if(!value){
                if(label !== ''){
                    return label +" is Required";
                }
                return "Field is required";
            }
        }else if (!value || value.trim() === "") {
            if(label !== ''){
                return label +" is Required";
            }
            return "Field is required";
        }
        return false;
    };
    
    const openWidgetConfig = (row) => {
        if(row){
            let agent_id = row["agent_id"];
            const selectedOption = agentsList.find(option => option.value === agent_id);
            const updatedRow = {
                ...row,
                agent: selectedOption,
            }
            setRowData(updatedRow);
        }else{
            loadDefaultData()
        }
        reset()
        setIsConfigView(!isConfigView);
    }

    const toggleModalVisiblity = () => {
        isGenerateCode = true;
        saveData();
        
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const getWidgetCodeContainer = () => {
        return (
            <Modal className={'webiste-chat-modal'} size="lg" isOpen={showModal} >
                <ModalHeader toggle={closeModal}>
                    {"Copy and paste this code before the </Body> tag on every page of your website."}
                </ModalHeader>
                <ModalBody>
                    <div className={'p-4'}>
                        <div className={'website-scripttag'}>
                            <div className="mb-4">
                                <CopyToClipboard onCopy={(e) => {setTextCopied(true)}} text={scriptTagContent}>
                                    <Button className={'copy-btn float-right'}>
                                        {isCopied ? "Copied!" : "Copy to Clipboard"}
                                    </Button>
                                </CopyToClipboard>
                                <br/>
                            </div>
                            <div className={'website-script-content'}>
                                <pre id={"code"}>
                                    <pre className={"script-code"}>
                                        <code style={{ whiteSpace: "pre"}}>
                                            {scriptTagContent}
                                        </code>
                                    </pre>
                                </pre>
                            </div>
                            {/* <div className="hide"><p className="text-sm text-right py-3">Still you want edit the widget <a
                                data-cy="click-here-link" className="cursor-pointer"
                                onClick={(e) => {getWidgetCodeContainer(e)}}>Click here</a></p>
                            </div> */}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    const getConfigViewContainner = () => {
        let brand_logo = rowData['brand_logo'];
        brand_logo = brand_logo ? parseJSON(brand_logo) : {};
        let mediaUrl = Object.keys(brand_logo).length > 0 ? brand_logo["mediaUrl"] : "";
        let fileName = Object.keys(brand_logo).length > 0 ? brand_logo["fileName"] : "";
        let isMobileView = isMobile();
        return(
            <Fragment>
                <div className={`${isMobileView ? "pb-5" : "d-flex"}`}>
                    <div className={`${isMobileView ? "w-100 with-border" : "w-50"} screen-1 `}>
                        <Form className="m-3 mb-4" onSubmit={ handleActionFormSubmit(onSubmitData) }>
                            {rowData?.['id'] !== "" &&  rowData?.['id'] !== undefined &&
                                <div className='mb-3'>
                                    <div className='main-card scrollable-table dns-error card w-75'>
                                        <span className='del-subaccount-header  d-flex p-1 gap-2 align-items-center'><i class="fi fi-rr-exclamation dns-error-icon ms-2 align-items-center"></i>{"After updating your widget, you must Regenerate Widget Code and re-embed the code on your site for changes to take effect."}</span>
                                    </div>
                                </div>
                            }
                            <FormGroup>
                                <Label>Widget name</Label>
                                <Controller
                                    name="name"
                                    control={control}
                                    rules={{ required: fieldValidate("name","Widget Name") }}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="name"
                                            autoComplete="off"
                                            placeholder="Widget name"
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                field.onChange(e);
                                            }}
                                            value={rowData["name"]}
                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                        />
                                    )}
                                />
                                {errors.name && <em className="mb-2 error invalid-feedback">{errors.name.message}</em>}
                            </FormGroup>
                            <FormGroup>
                                <Label>Brand name</Label>
                                <Controller
                                    name="brand_name"
                                    control={control}
                                    rules={{ required: fieldValidate("brand_name","Brand name") }}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="brand_name"
                                            autoComplete="off"
                                            placeholder="Brand name"
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                field.onChange(e);
                                            }}
                                            value={rowData["brand_name"]}
                                            className={`form-control ${errors.brand_name ? 'is-invalid' : ''}`}
                                        />

                                    )}
                                />
                                {errors.brand_name && <em className="mb-2 error invalid-feedback">{errors.brand_name.message}</em>}
                            </FormGroup>
                            <FormGroup>
                                <Label>Brand logo</Label>
                                <CratioFileUploader
                                    name="brand_logo" 
                                    comWidth={196} 
                                    comHeight={28} 
                                    fileName={fileName ?? ""}
                                    mediaUrl={mediaUrl ?? ""}
                                    errors={{}} 
                                    handleFile={handleFileUpload} 
                                    clearFile={clearFile} 
                                    isAdmin={isAdmin}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Subtitle</Label>
                                <Controller
                                    name="subtitle"
                                    control={control}
                                    rules={{ required: fieldValidate("subtitle") }}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="subtitle"
                                            autoComplete="off"
                                            placeholder="Subtitle"
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                field.onChange(e);
                                            }}
                                            value={rowData["subtitle"]}
                                            className={`form-control ${errors.subtitle ? 'is-invalid' : ''}`}
                                        />
                                    )}
                                />
                            {errors.subtitle && <em className="mb-2 error invalid-feedback">{errors.subtitle.message}</em>}
                            </FormGroup>
                            <FormGroup>
                                <Label>Button color</Label>
                                <Controller
                                    name="button_color"
                                    control={control}
                                    rules={{ required: fieldValidate("button_color") }}
                                    render={({ field }) => (
                                        <div className="d-flex align-items-center box-color rounded px-2">
                                            <input
                                                type="color"
                                                id="button_color"
                                                name="button_color"
                                                value={rowData["button_color"] ? rowData["button_color"] : ""}
                                                onChange={(e) => {
                                                    handleInputChange(e);
                                                    field.onChange(e);
                                                }}
                                                style={{ border: 'none', background: 'none', width: '25px', height: '20px', padding: '0' }}
                                            />
                                            <input
                                                type="text"
                                                name="button_color"
                                                className="form-control border-0 ms-2"
                                                value={rowData["button_color"]}
                                                onChange={(e) => {
                                                    handleInputChange(e);
                                                    field.onChange(e);
                                                }}
                                            />
                                        </div>
                                    )}
                                />
                                {errors.button_color && <em className="mb-2 error invalid-feedback">{errors.button_color.message}</em>}
                            </FormGroup>
                            <FormGroup>
                                <Label>Text color scheme</Label>
                                <div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="light"
                                            value="light"
                                            name="text_color"
                                            checked={rowData["text_color"] === "light"}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                            }}
                                            className={`form-check-input ${errors.text_color ? 'is-invalid' : ''}`}
                                        />
                                        <label htmlFor="light" className="form-check-label">Light</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="dark"
                                            value="dark"
                                            name="text_color"
                                            checked={rowData["text_color"] === "dark"}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                            }}
                                            className={`form-check-input ${errors.text_color ? 'is-invalid' : ''}`}
                                        />
                                        <label htmlFor="dark" className="form-check-label">Dark</label>
                                    </div>
                                    {
                                        errors.text_color && (
                                            <div className="invalid-feedback d-block">{errors.text_color.message}</div>
                                        )
                                    }
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <Label>Select agent</Label>
                                <Controller
                                    name="agent"
                                    control={control}
                                    rules={{ required: fieldValidate("agent","Agent") }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            name="agent"
                                            options={agentsList}
                                            onChange={(e) => {
                                                handleInputChange(e, "agent");
                                                field.onChange(e);
                                            }}
                                            value={rowData["agent"]}
                                            className="basic-multi-select wa-select__control"
                                            classNamePrefix="wa-select"
                                        />
                                    )}
                                />
                                {errors.agent && <em className="mb-2 error invalid-feedback">{errors.agent.message}</em>}
                            </FormGroup>
                            <FormGroup>
                                <Label>Position</Label>
                                <div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="left"
                                            value="left"
                                            name="position"
                                            checked={rowData["position"] === "left"}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                            }}
                                            className={`form-check-input ${errors.position ? 'is-invalid' : ''}`}
                                        />
                                        <label htmlFor="left" className="form-check-label">Bottom left</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="right"
                                            value="right"
                                            name="position"
                                            checked={rowData["position"] === "right"}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                            }}
                                            className={`form-check-input ${errors.position ? 'is-invalid' : ''}`}
                                        />
                                        <label htmlFor="right" className="form-check-label">Bottom right</label>
                                    </div>
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <Label>Call bubble text</Label>
                                <Controller
                                    name="call_btn_text"
                                    control={control}
                                    rules={{ required: fieldValidate("call_btn_text") }}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="call_btn_text"
                                            autoComplete="off"
                                            placeholder="Call Button Text"
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                field.onChange(e);
                                            }}
                                            value={rowData["call_btn_text"]}
                                            className={`form-control ${errors.call_btn_text ? 'is-invalid' : ''}`}
                                        />
                                    )}
                                />
                                {errors.call_btn_text && <em className="mb-2 error invalid-feedback">{errors.call_btn_text.message}</em>}
                            </FormGroup>
                            <FormGroup>
                                <Label>Welcome text</Label>
                                <Controller
                                    name="welcome_text"
                                    control={control}
                                    rules={{ required: fieldValidate("welcome_text") }}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="welcome_text"
                                            autoComplete="off"
                                            placeholder="Welcome Text"
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                field.onChange(e);
                                            }}
                                            value={rowData["welcome_text"]}
                                            className={`form-control ${errors.welcome_text ? 'is-invalid' : ''}`}
                                        />
                                    )}
                                />
                                {errors.welcome_text && <em className="mb-2 error invalid-feedback">{errors.welcome_text.message}</em>}
                            </FormGroup>
                            <FormGroup>
                                <div className="form-group form-check">
                                    <input
                                        id="branding"
                                        type="checkbox"
                                        name="branding"
                                        onChange={(e) => {
                                            handleInputChange(e, "checkbox");
                                        }}
                                        checked={rowData["branding"]}
                                        className="form-check-input"
                                    />
                                    <label htmlFor="branding" className="form-check-label">
                                        Branding
                                    </label>
                                </div>
                            </FormGroup>
                            <button type="submit" className="hide" ref={savebtn}/>
                        </Form>
                    </div>
                    <div className="screen-2">
                        <WebCallContextProvider>
                            <WebsiteWidget data={rowData}/>
                        </WebCallContextProvider>
                        <div className="d-flex">
                            <Button className="theme-bg-g ms-auto me-auto" onClick={e => {toggleModalVisiblity()}}>Generate Widget Code</Button>
                        </div>
                    </div>
                    {
                        getWidgetCodeContainer()
                    }
                </div>
            </Fragment>
        )
    }

    const getListViewContainner = () => {
        return(
            <div className='agent-details agent_details-wid phone-numbers-container'>
                {!!formData && formData.length > 0 && <div className="card-fields">
                    <span className="heading">Your Widgets</span>
                    <span className="subheading">Below is a list of all widgets connect your agents</span>
                </div>}
                {
                    formData && formData.length > 0 ? (formData.map((data, index) => (
                        <div className={`number-hover gap-0 ${isMobile() ? "" : "me-5"}`} key={index} onClick={() => openWidgetConfig(data)}>
                            <span className='cloud-number-logo'>
                                <i class="fi fi-rr-browser"></i>
                            </span>
                            <span className='cloud-number-name-number'>
                                <p className="name">{data["name"]}</p>
                                <p className="number">{data["status"]}</p>
                            </span>
                            <span className='settings-i-cont me-2' onClick={(e) => e.stopPropagation()}>
                                <Switch
                                    onColor={"#23ae73"}
                                    offColor="#888888"
                                    onChange={() => updateStatus(data)}
                                    checked={data.status === "Active"}
                                    width={50}
                                    height={20}
                                />
                            </span>
                            <span className='settings-i-cont' onClick={e => {e.stopPropagation(); deleteData(data.id, data.name)}}>
                                <i class="fi fi-rr-trash"></i>
                            </span>
                        </div>)
                    ))
                    :
                    (
                        <NoRecordFound
                            isOnlyContent={true}
                        />
                    )
                }
            </div>
        )
    }

    const getTitleBody = () => {
        return (
            <Fragment>
                {
                    isMobile() ? (
                        <div className="d-flex mt-3 p-3 gap-3">
                            {
                                isConfigView ? (
                                    <>
                                        <a className="custom-btn-1 btn btn-dark cursor-pointer mr-1 ms-auto w-100" onClick={e => openWidgetConfig(null)}>
                                            Cancel
                                        </a> 
                                        <Button className="theme-bg-g ms-auto w-100" onClick={e => saveData()}>
                                            Save
                                        </Button>
                                    </>
                                ) : (
                                    <Button className="theme-bg-g ms-auto" onClick={e => setIsConfigView(true)}>
                                        <FontAwesomeIcon icon={faPlus} /><span className="ps-1">Add</span>
                                    </Button>
                                )
                            }
                        </div>
                    ) : (
                        isConfigView ? (
                            <>
                                <a className="custom-btn-1 btn btn-dark cursor-pointer mr-1 m-1" onClick={e => openWidgetConfig(null)}>
                                    Cancel
                                </a> 
                                <Button className="theme-bg-g" onClick={e => saveData()}>
                                    Save
                                </Button>                  
                            </>
                        ) : (
                            <Button className="theme-bg-g" onClick={e => setIsConfigView(true)}>
                                <FontAwesomeIcon icon={faPlus} /><span className="ps-1">Add</span>
                            </Button>
                        )
                    )
                }
            </Fragment>
        );
    }

    return(
        <Fragment>
            <Common
                title={
                    "Widgets"
                }
                mainLoader={showLoader}
                titleContent={
                    isConfigView ? (
                        <div className='container-heading-title'>
                            <span onClick={e => openWidgetConfig(null)} className="cursor-pointer hide">
                                <i class="fi fi-rr-arrow-left"></i>
                            </span>
                            <span>{rowData["name"]}</span>
                        </div>
                    ) : (
                        "Widgets"
                    )
                }
                titleBody={
                    !isMobile() && getTitleBody()
                }
                mainContent={
                    <Container fluid>
                        <div className="widget-container">
                            {
                                isMobile() && getTitleBody()
                            }
                            {
                                isConfigView ? (
                                    getConfigViewContainner()
                                ) : (
                                    getListViewContainner()
                                )
                            }
                        </div>
                    </Container>
                }
                // titleKey={"widgets_allowed"}
            />
        </Fragment>
    )
}

const mapStateToProps = (state) => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle,
});

const mapDispatchToProps = (dispatch) => ({
    setAppCustomTitle: (title) => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Widgets);